import React, { useEffect, useRef, useState } from "react";
import Header from "../../components/global/Header";
import LeftNavbar from "../../components/global/LeftNavbar";
import { useTranslation } from "react-i18next";
import SourceMaterialUpload from "./SourceMaterialUpload";
import ReferenceMaterialUpload from "./ReferenceMaterialUpload";
import { transformBlankToNull, timeStamp } from "../../services/Util";
import { Link, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getAxiosResponse, postAxiosResponse } from "../../services/authApiRoutes/APImethods";
import APIUrls from "../../services/APIUrls";
import Constants from "../../Constants";
import $, { post } from "jquery";
import Select from "react-select";
import Calendar from "react-calendar";
import { dateFormat } from "../../services/Util";
import ProjectRequestIntegration from "./ProjectRequestIntegration";
import { updateProjectRequestIntegrationValue, resetProjectRequestIntegrationValue } from "../../redux/reducers/ProjectRequestIntegrationSlice";
import DataTable, { createTheme } from "react-data-table-component";
import { getSelectedAssets } from '../../services/IntegrationUtil'
import { Breadcrumb } from "../../components/dashboard/Breadcrumb";
import { handleError } from "../../services/authApiRoutes/APImethods";
import DateFormat from "../../pages/DateFormat";
import store from "../../redux/store";

export default function CreateProjectRequest() {
  const scrollRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const aaaSelected = useSelector((aaaChecked) => aaaChecked.contrast).value;
  const theme = aaaSelected ? "dark" : "";

  const priorities = [
    { value: "", label: "Select One" },
    { value: "HIGHEST", label: "Highest (1)" },
    { value: "HIGH", label: "High (2)" },
    { value: "MEDIUM", label: "Medium (3)" },
    { value: "LOW", label: "Low (4)" },
    { value: "LOWEST", label: "Lowest (5)" },
  ];

  const assetColumns = [
    {
      id: "asset.displayName",
      name: "Name",
      selector: (asset) => asset[projectRequestIntegrationRedux.displayName],
      sortable: true,
      cell: (asset) => asset[projectRequestIntegrationRedux.displayName],
    },
    {
      id: "sourceLanguage.display",
      name: "Source Language",
      selector: (asset) => projectRequestIntegrationRedux.sourceLanguage,
      sortable: false,
      cell: (asset) => projectRequestIntegrationRedux.sourceLanguage?.display,
    },
    {
      id: "targetLanguage.display",
      name: "Target Language",
      wrap: false,
      selector: (asset) => asset?.targetLanguages,
      sortable: false,
      cell: (asset) => new String(asset?.targetLanguages?.map(targetLanguage => (targetLanguage?.display))),
    }
  ];

  const translate = t;
  const [isLoading, setIsLoading] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [validationErrors, setValidationErrors] = useState({});
  const [toggleIntialCal, toggleIntialCalFlag] = useState(false);
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [campaigns, setCampaigns] = useState([]);
  const [poNumbers, setPoNumbers] = useState([]);
  const [selectedPONumber, setSelectedPONumber] = useState("");
  const [tags, setTags] = useState([]);
  const [filteredTags, setFilteredTags] = useState([])
  const [selectedTags, setSelectedTags] = useState([]);
  const [requestName, setRequestName] = useState("");
  const [requestNote, setRequestNote] = useState("");
  const refToggle2 = useRef(null);
  const refCalendar2 = useRef(null);
  const [selectedCampaign, setSelectedCampaign] = useState("");
  const [selectedPriority, setSelectedPriority] = useState("");
  const [sourceLanguages, setSourceLanguages] = useState([]);
  const [selectedSourceLanguage, setSelectedSourceLanguage] = useState("");
  const [targetLanguages, setTargetLanguages] = useState([]);
  const [translationDueDate, setTranslationDueDate] = useState("");
  const [filteredTargetLanguage, setFileredTargetLanguage] = useState([]);
  const [selectedTargetLanguages, setSelectedTargetLanguages] = useState([]);
  const [requestType, setRequestType] = useState("");
  const [descriptiveSource, setDescriptiveSource] = useState("");
  const [showIntegration, setshowIntegration] = useState(false);
  const [contentType, setContentType] = useState();
  const [contentName, setContentName] = useState();
  const [languageGroup,setLanguageGroup] = useState([]);
	const [languageGroupValues,setLanguageGroupValues] = useState({});

  const ProjectRequestIntegrationMemo = React.memo(ProjectRequestIntegration);
  const projectRequestIntegrationRedux = useSelector((redux) => redux.project_request_integration).value;

  const customerTimeZone = store.getState()?.customer_bootstrap_data?.value?.user?.timeZone;

  const backRef = useRef();

  const dispatchToProjectRequestIntegrationRedux = (type, value) => {
    dispatch(
      updateProjectRequestIntegrationValue({
        type: type,
        value: value,
      })
    );
  };

  const hideModalFun = () => {
    document.body.classList.remove("modal-open");
  };
  const selectDepartment = (value) => {
    if (value.value !== "") {
      setSelectedDepartment(value.value);
      setValidationErrors({});
    } else {
      setSelectedDepartment({});
    }
  };
  const sourceDocument = useSelector((projectRequestSourceDocument) => projectRequestSourceDocument.project_request_source_material).value;
  const referenceDocument = useSelector((projectRequestReferenceDocument) => projectRequestReferenceDocument.project_request_reference_material).value;
  const permissions = useSelector((reduxStore) => reduxStore.customer_bootstrap_data).value?.permissions;

  const selectCampaign = (value) => {
    if (value.value !== "") {
      setSelectedCampaign(value.value);
    } else {
      setSelectedCampaign({});
    }
  };

  const selectPriority = (value) => {
    if (value.value !== "") {
      setSelectedPriority(value.value);
    } else {
      setSelectedPriority("");
    }
  };

  const selectTag = (value) => {
    let localSelectedTags = selectedTags;
    let duplicatTag = selectedTags.find(tag => tag.display === value.display)
    if (!duplicatTag) {
      localSelectedTags.push(value);
    }
    setSelectedTags(localSelectedTags);

    let tagsLabel = localSelectedTags.map(tag => tag.display);
    setFilteredTags(tags.filter(tag => !tagsLabel.includes(tag.label)));
  };

  const selectTagKeyDown = (event) => {
    if (event.code === Constants.ENTER) {
      event.preventDefault()
      let value = event.target?.value.trim();
      selectTag({display : value});
      event.target.value = "";
    }
  }

  const removeTag = (value) => {
    setFilteredTags((current) => [...current, { label: value.display, value: value }]);
    var remaining = selectedTags.filter(tag => tag.display !== value.display);
    setSelectedTags(remaining);
  };

  const selectPONumber = (value) => {
    if (value.value !== "") {
      setSelectedPONumber(value.value);
    } else {
      setSelectedPONumber("");
    }
  };

  const hideModal = () => {
    hideModalFun();
    $("#eloquaAssets").trigger("focus");
  };
  $(document).on("click", ".openOption", function () {
    $("input:not(:checked)").parent().next().removeClass("checked");
    $("input:checked").parent().next().addClass("checked");
  });
  $(document).on("click", "#eloquaAssets", function () {
    //$("input:checked").parents("body").addClass("modal-open");
    setTimeout(() => {
      $(".first-focus").trigger("focus");
      $(".first-focus").on("keydown", function (e) {
        if (e.key === Constants.TAB) {
          if (e.shiftKey === true) {
            e.preventDefault();
            $("#dasboardBtn").trigger("focus");
          }
        }
      });
      // $(".inner-lightbox-panel").on("keydown", function (e) {
      //   if (e.key === Constants.ESCAPE) {
      //     hideModalFun();
      //   }
      // });
    }, 500);
  });
  const handleKeyAddflow = (event) => {
    if (event.key === Constants.TAB) {
      if (event.shiftKey === false) {
        event.preventDefault();
        $("#dasboardBtn").trigger("focus");
      }
    }
  };
  const showCalendarDiliveryDate = () => {
    toggleIntialCal ? toggleIntialCalFlag(false) : toggleIntialCalFlag(true);
    if (toggleIntialCal) {
      var requiredElement = document.querySelector(".dashCalendar2");
      requiredElement?.focus();
    }
  };
  const closeCalendar = (e) => {
    if (e.code === "Escape") {
      toggleIntialCalFlag(false);
    }
  };
  const handleTranslationDueDate = (event) => {
    setTranslationDueDate(event);
    toggleIntialCalFlag(false);
  };
  const handleSourceLanguageChange = (value) => {
    setSelectedSourceLanguage(value.value);
  };

  useEffect(() => {
    if (selectedSourceLanguage !== "" && targetLanguages?.length > 0) {
      setFileredTargetLanguage(targetLanguages.filter(lang => selectedSourceLanguage?.code !== lang.value?.code));
    }
  }, [selectedSourceLanguage, targetLanguages])

  const handleTargetLanguageChange = (event) => {
    var selectedLang = event;
    var langArray = [];
    if(selectedLang.isGroup && selectedLang.isSelected === false){
      let data = languageGroup.map((grp)=>{
        if(grp.label === selectedLang.label){
          grp.isSelected = true;
        }
        return grp;
      });
      setLanguageGroup(data);
      let grpValues = languageGroupValues[selectedLang.value];
      const selectedLanguages = selectedTargetLanguages.map(lang=>lang.code);
      grpValues.forEach(val=>{
        if(!selectedLanguages.includes(val.code)){
          let lang = {language:val.name,code:val.code,display:val.display};
          setSelectedTargetLanguages((current) => [...current, lang]);
        }
      })
    }else if(selectedLang.isGroup === undefined){
      if (selectedLang.value === "all") {
        filteredTargetLanguage.map((langs) => {
          if (langs.value !== "all") {
            langArray.push(langs.value);
          }
        });
        setFileredTargetLanguage([]);
        setSelectedTargetLanguages(langArray);
      } else {
        setSelectedTargetLanguages((current) => [...current, selectedLang.value]);
      }
    }
    setTimeout(function () {
      $(".lang-second div button").removeClass("lastFocus");
    }, 900);
    setTimeout(function () {
      $(".lang-second div:last button").addClass("lastFocus");
    }, 1000);
  };

  useEffect(() => {
    if (targetLanguages?.length > 0) {
      let selectedTargs = selectedTargetLanguages.map((lang) => lang.code);
      let filteredLanguage = targetLanguages.filter((lang) => {
        return !selectedTargs.includes(lang.value?.code) && (selectedSourceLanguage === "" || selectedSourceLanguage?.code !== lang.code)
      });
      setFileredTargetLanguage(filteredLanguage);
    }
  }, [selectedTargetLanguages, targetLanguages])

  const removeTargetLanguage = (selected) => {
    Object.keys(languageGroupValues).forEach((key,val)=>{
      let updatedGrps = languageGroup.map(grp=>{
        if(key === grp.label){
          let array = languageGroupValues[key].map(o=>o.code);
          if(array.includes(selected.code)){
            grp.isSelected = false;
          }
        }
        return grp;
      })
      setLanguageGroup(updatedGrps);
    });
    var result = selectedTargetLanguages.filter((selectedLangs) => {
      return selectedLangs.code !== selected.code;
    });
    setSelectedTargetLanguages(result);
    if ($(".lang-second div").length <= 1) {
      $(".stricy-btn .left div:last button").trigger("focus");
    }
  };
  const getAllData = () => {
    getAxiosResponse(APIUrls.ALL_DEPARTMENT)
      .then((res) => {
        if (res.data !== "") {
          var options = [{ label: "Select One", value: "" }];
          res.data.data.map((depart) => {
            options.push({
              label: depart.name,
              value: depart,
            });
          });
          setDepartments(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.PROJECT_LISTING_PURCHASE_ORDERS)
      .then((res) => {
        if (res.data !== "") {
          var options = [{ label: "Select One", value: "" }];
          res.data.data.map((po) => {
            if (po.poName !== po.poNumber) {
              options.push({
                label: po.poNumber + " (" + po.poName + ")",
                value: po,
              });
            } else {
              options.push({ label: po.poName, value: po });
            }
          });
          setPoNumbers(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.WORKSPACE_LIST + `?onlyMember=false&onlyOpen=true&showProgress=false`)
      .then((res) => {
        if (res.data !== "") {
          var options = [{ label: "Select One", value: "" }];
          res.data.data.result.map((campaign) => {
            options.push({
              label: campaign.name,
              value: campaign,
            });
          });
          setCampaigns(options);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        handleError(err);
      });

    getAxiosResponse(APIUrls.TAGS)
      .then((res) => {
        if (res.data !== "") {
          var options = [];
          res.data.data.result.map((tag) => {
            options.push({
              label: tag.display,
              value: tag,
            });
          });
          setTags(options);
        }
      })
      .catch((err) => {
        handleError(err);
      });
  };

  useEffect(() => {
    let tagsLabel = selectedTags?.map(tag => tag.display);
    setFilteredTags(tags?.filter(tag => !tagsLabel.includes(tag.label)));
  }, [tags, selectedTags])

  useEffect(() => {
    dispatch(resetProjectRequestIntegrationValue());
    var sourceLangArray = [];
    var targetLangArray = [{ label: "-- Select All -- ", value: "all" }];
    var defaultSelectedTargetLangArray = [];
    var selectedTargetLangArray = [];
    getAxiosResponse(APIUrls.GET_ACCOUNT_SOURCE_LANGUAGES)
      .then((res) => {
        if (res.data !== "") {
          res.data.data.map((lang) => {
            sourceLangArray.push({
              label: lang.display,
              value: lang,
            });
          });
          setSourceLanguages(sourceLangArray);
        }
      })
      .catch((err) => {
        handleError(err);
      });
    Promise.all([getAxiosResponse(APIUrls.GET_ACCOUNT_TARGET_LANGUAGES),
    getAxiosResponse(APIUrls.GET_CUSTOMER_LANGUAGE_GROUP)])
    .then(([targetLanguagesResponse,languageGroupResponse])=>{
      const data = languageGroupResponse.data.data
      let langGrp = [{label:"-- Select Preset Group --",value:"",language:""}]
			if(data){
				let values = {};
				data.forEach((o)=>{
					values[o?.resource?.name] = o.displayName[0];
					langGrp.unshift({label:o?.resource?.name,value:o?.resource?.name,isGroup:true,isSelected:false})
				});
				setLanguageGroupValues(values);
				setLanguageGroup(langGrp);
			}
      if (targetLanguagesResponse.data !== "") {
        if(langGrp.length>1){
          langGrp.forEach((o)=>{
            if(!o.isSelected){
              targetLangArray.unshift(o);
            }
          })
        }
        targetLanguagesResponse.data.data.map((lang) => {
          targetLangArray.push({
            label: lang.display,
            value: lang,
          });
        });
        setTargetLanguages(targetLangArray);
        setFileredTargetLanguage(targetLangArray);
      }
    }).catch(err=>{
      handleError(err);
    })
      getAllData();
  }, []);

  $(".lang-second div:last button, .lang-first div:last button").addClass("lastFocus");
  $(document).on("click", ".lastFocus", function () {
    $(".stricy-btn .left div:last button").trigger("focus");
  });
  
  const createRequest = () => { 
    setValidationErrors("");
    var errors = [];
    if (selectedCampaign !== "") {
      selectedCampaign.workspaceMembers = null;
      selectedCampaign.userAndCountResources = null;
      selectedCampaign.projectStatusCount = null;
      selectedCampaign.dueDateInPast = false;
      selectedCampaign.dueDate = null;
    }

    var allTagPayload = [];
    if (selectedTags.length > 0) {
      selectedTags.map((tag) => {
        allTagPayload.push(tag.display);
      });
    }
    var defaultPayload = {
      name: requestName,
      status: "OPEN",
      description: null,
      translationDueDate: timeStamp(translationDueDate, customerTimeZone),
      requestTargetLanguages: getTargetLanguages(),
      sourceMaterial: sourceDocument.length !== 0 ? sourceDocument : null,
      referenceMaterials: referenceDocument,
      sourceLanguage: getSourceLanguage(),
      tags: allTagPayload,
      priority: selectedPriority,
      workspace: selectedCampaign !== "" ? selectedCampaign : null,
      supportMultiSource: true,
      notes: requestNote,
      purchaseOrder: selectedPONumber,
      assets: getAssets(),
      sourceMaterialDescription: descriptiveSource,
      requestSourceType: requestType,
    };
    if (selectedDepartment.id !== undefined) {
      defaultPayload.userGroup = { id: selectedDepartment.id };
    }
    var finalPayload = transformBlankToNull(defaultPayload);

    postAxiosResponse(APIUrls.POST_PROJECT_REQUEST, finalPayload).then((res) => {
      let error=res?.data?.handledMessage;
        if(!error){
          if (res.data?.data?.body?.errors) {
            setValidationErrors(res.data.data.body.errors);
          } else {
            navigate(`/project-request/show/${res.data?.data?.body?.id}`);
          }
        }else{
          setValidationErrors({msg:error}) 
        }
      
    });
  };

  const getAssets = () => {
    let assets = getSelectedAssets(projectRequestIntegrationRedux.contentType, projectRequestIntegrationRedux.selectedAssets, projectRequestIntegrationRedux.sourceLanguage);
    // if (assets?.length > 0) {
    //   assets.forEach(asset => {
    //     asset.language = {code: asset.langCode};
    //   })
    // }
    return assets;
  }

  const getSourceLanguage = () => {
    let sourceLanguage;
    if (projectRequestIntegrationRedux.sourceLanguage) {
      sourceLanguage = projectRequestIntegrationRedux.sourceLanguage?.language;
    } else {
      sourceLanguage = selectedSourceLanguage.language
    }
    return sourceLanguage
  }

  const getTargetLanguages = () => {
    let targetLanguages = [];

    if (projectRequestIntegrationRedux.targetLanguages?.length > 0) {
      const uniqueLanguages = projectRequestIntegrationRedux.targetLanguages.filter((lang, index, self) =>
        index === self.findIndex((t) => t.code === lang.code)
      );

      targetLanguages = [...uniqueLanguages.map(lang => ({
        code: lang.code,
        language: lang.language || lang.name,
        assigneeUser: null
      }))];
    } else if (selectedTargetLanguages.length > 0) {
      targetLanguages = [...selectedTargetLanguages.map(lang => ({
        language: lang.language || lang.name,
        assigneeUser: null,
      }))];
    }
    
    return targetLanguages;
  }

  const openIntegrationModel = () => {
    document.body.classList.add("modal-open");
  };

  const setTitle = () => {
    if (projectRequestIntegrationRedux.contentType === Constants.MARKETOREST) {
      return "Marketo v2.0 assets"
    } else if (projectRequestIntegrationRedux.contentType === Constants.ELOQUA){
      return "Eloqua assets"
    } else if (projectRequestIntegrationRedux.contentType === Constants.BRIGHTCOVE){
      return "Brightcove assets"
    }
    return ""
  }

  const openIntegration = (event, contentType, contentName, requestType) => {
    $("#project-request-source-material").addClass("hide").removeClass("checked");
    if (selectedDepartment?.id) {
      setContentType(contentType);
      setContentName(contentName);
      setRequestType(requestType);
      //dispatchToProjectRequestIntegrationRedux("contentType", contentType);
      dispatchToProjectRequestIntegrationRedux("contentName", contentName);
      dispatchToProjectRequestIntegrationRedux("isProjectRequest", true);
      openIntegrationModel();
      setshowIntegration(true);
    } else {
      setshowIntegration(false);
      setValidationErrors({userGroup : "Select Department"});
      $(".integration-check-input").prop("checked", false);
    }
  }
  const crumbs = [
    {label:'Project Request', url:''},
  ];
  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
        <Header ref={scrollRef} />
        <LeftNavbar />
        <section className="dashboard-content" ref={scrollRef} tabIndex={0}>
          <div id="content" className="dashboard-wrap campaign-section">
            <Breadcrumb crumbs={ crumbs } />
            <div className="translate-request-page">
              <div className="white-bg mar-bot50">
                <div className="translate-heading">
                  <h4>Translation Request</h4>
                  <p>Enter your translation request details below. Add as much detail as you can to make sure your transaltion projects runs smoothly</p>
                </div>
                <div className="flex wrap-dropdown wrap-dropdown-gap">
                  <div className="global-dropdown-block flex-center">
                    <label>Department</label>
                    <Select
                      classNamePrefix="cw"
                      className="global-dropdown-select"
                      menuShouldScrollIntoView={false}
                      closeMenuOnSelect={true}
                      options={departments}
                      onChange={(e) => selectDepartment(e)}
                      placeholder="Select One"
                      defaultValue={{ label: "Select Department" }}
                      value={departments.filter(function (option) {
                        return option.value.id === selectedDepartment.id;
                      })}
                    />
                    {validationErrors.userGroup ? <div className="error">{validationErrors.userGroup}</div> : null}
                  </div>
                  <div className="global-dropdown-block flex-center">
                    <label>Request Name</label>
                    <input type="text" className="form-control-sm" title="50 Characters Left" onChange={(e) => setRequestName(e.target.value)} />
                    {validationErrors.name ? <div className="error">{validationErrors.name}</div> : null}
                  </div>
                  <div className="global-dropdown-block flex-center">
                    <label>
                      Campaign <span>Optional</span>{" "}
                    </label>
                    <Select
                      classNamePrefix="cw"
                      className="global-dropdown-select"
                      menuShouldScrollIntoView={false}
                      closeMenuOnSelect={true}
                      options={campaigns}
                      isLoading={isLoading}
                      onChange={(e) => selectCampaign(e)}
                      placeholder="Select One"
                      defaultValue={{ label: "Select Campaign" }}
                      value={campaigns.filter(function (option) {
                        return option.value.id === selectedCampaign.id;
                      })}
                    />
                  </div>
                  <div className="global-dropdown-block flex-center">
                    <label>
                      Priority <span>Optional</span>
                    </label>
                    <Select
                      classNamePrefix="cw"
                      className="global-dropdown-select"
                      menuShouldScrollIntoView={false}
                      closeMenuOnSelect={true}
                      defaultValue={{ label: "Select Priority" }}
                      options={priorities}
                      onChange={(e) => selectPriority(e)}
                      value={priorities.filter(function (option) {
                        return option.value === selectedPriority;
                      })}
                    />
                  </div>
                  <div className="global-dropdown-block flex-center">
                    <label className="label-tooltip width-auto relative">
                        Translations Due Date
                        <div className="gb-tooltip" role="tooltip" aria-label="tooltip content" tabIndex="0" aria-expanded="false">
                          <span>
                            <svg className="svg-tooltip-icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg">
                              <path d="M512 81.408a422.4 422.4 0 1 0 422.4 422.4A422.4 422.4 0 0 0 512 81.408z m26.624 629.76a45.056 45.056 0 0 1-31.232 12.288 42.496 42.496 0 0 1-31.232-12.8 41.984 41.984 0 0 1-12.8-30.72 39.424 39.424 0 0 1 12.8-30.72 42.496 42.496 0 0 1 31.232-12.288 43.008 43.008 0 0 1 31.744 12.288 39.424 39.424 0 0 1 12.8 30.72 43.008 43.008 0 0 1-13.312 31.744z m87.04-235.52a617.472 617.472 0 0 1-51.2 47.104 93.184 93.184 0 0 0-25.088 31.232 80.896 80.896 0 0 0-9.728 39.936v10.24h-64v-10.24a119.808 119.808 0 0 1 12.288-57.344A311.296 311.296 0 0 1 555.52 460.8l10.24-11.264a71.168 71.168 0 0 0 16.896-44.032A69.632 69.632 0 0 0 563.2 358.4a69.632 69.632 0 0 0-51.2-17.92 67.072 67.072 0 0 0-58.88 26.112 102.4 102.4 0 0 0-16.384 61.44h-61.44a140.288 140.288 0 0 1 37.888-102.4 140.8 140.8 0 0 1 104.96-38.4 135.68 135.68 0 0 1 96.256 29.184 108.032 108.032 0 0 1 36.352 86.528 116.736 116.736 0 0 1-25.088 73.216z" />
                            </svg>
                          </span>
                          <div className="wrap-tooltip-content">
                            <div className="gb-tooltip-content">
                              <div className="triangle"></div>
                              <strong>Translations Due Date</strong>
                              <p>
                                The time is 5 PM of the day that you choose.
                              </p>
                            </div>
                          </div>
                        </div>
                      </label>
                    <div className="flex-center w-d100 translationDate">
                      <div className="global-dropdown-select " aria-label="I need initial translation by">
                        <button
                          onClick={(e) => {
                            showCalendarDiliveryDate(e);
                          }}
                          ref={refToggle2}
                          tabIndex={0}
                          type="button"
                          className="drop-down-btn gb-dropBtn">
                          <span><DateFormat date={translationDueDate} timezone={null} /></span>
                          <svg className="calender-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none">
                            <path
                              d="M12 1.66666H10V0.666662C10 0.578256 9.96492 0.493472 9.90241 0.430959C9.8399 0.368447 9.75511 0.333328 9.66671 0.333328C9.5783 0.333328 9.49352 0.368447 9.431 0.430959C9.36849 0.493472 9.33337 0.578256 9.33337 0.666662V1.66666H4.66671V0.666662C4.66671 0.578256 4.63159 0.493472 4.56908 0.430959C4.50656 0.368447 4.42178 0.333328 4.33337 0.333328C4.24497 0.333328 4.16018 0.368447 4.09767 0.430959C4.03516 0.493472 4.00004 0.578256 4.00004 0.666662V1.66666H2.00004C1.55818 1.66719 1.13456 1.84296 0.822114 2.1554C0.509668 2.46785 0.333903 2.89146 0.333374 3.33333V12C0.333903 12.4419 0.509668 12.8655 0.822114 13.1779C1.13456 13.4904 1.55818 13.6661 2.00004 13.6667H12C12.442 13.6663 12.8657 13.4906 13.1782 13.1781C13.4906 12.8656 13.6664 12.4419 13.6667 12V3.33333C13.6664 2.89141 13.4906 2.46769 13.1782 2.15521C12.8657 1.84272 12.442 1.66701 12 1.66666ZM13 12C13 12.2652 12.8947 12.5196 12.7071 12.7071C12.5196 12.8946 12.2653 13 12 13H2.00004C1.73482 13 1.48047 12.8946 1.29293 12.7071C1.1054 12.5196 1.00004 12.2652 1.00004 12V6.33333H13V12ZM13 5.66666H1.00004V3.33333C1.00004 2.78133 1.44671 2.33333 2.00004 2.33333H4.00004V3.33333C4.00004 3.42173 4.03516 3.50652 4.09767 3.56903C4.16018 3.63154 4.24497 3.66666 4.33337 3.66666C4.42178 3.66666 4.50656 3.63154 4.56908 3.56903C4.63159 3.50652 4.66671 3.42173 4.66671 3.33333V2.33333H9.33337V3.33333C9.33337 3.42173 9.36849 3.50652 9.431 3.56903C9.49352 3.63154 9.5783 3.66666 9.66671 3.66666C9.75511 3.66666 9.8399 3.63154 9.90241 3.56903C9.96492 3.50652 10 3.42173 10 3.33333V2.33333H12C12.2653 2.33333 12.5196 2.43868 12.7071 2.62622C12.8947 2.81376 13 3.06811 13 3.33333V5.66666Z"
                              fill="#3564EB"
                            />
                          </svg>
                        </button>
                      </div>

                      {toggleIntialCal ? (
                        <div
                          ref={refCalendar2}
                          onKeyDown={(e) => {
                            closeCalendar(e);
                          }}>
                          <Calendar value={new Date()} minDate={new Date()} className={"dashCalendarInternal"} onChange={(e) => handleTranslationDueDate(e)}></Calendar>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    {validationErrors.translationDueDate ? <div className="error">{validationErrors.translationDueDate}</div> : null}
                  </div>
                  <div className="global-dropdown-block flex-center">
                    <label>
                      Purchase Order Number <span>Optional</span>
                    </label>
                    <Select
                      classNamePrefix="cw"
                      className="global-dropdown-select"
                      menuShouldScrollIntoView={false}
                      closeMenuOnSelect={true}
                      defaultValue={{ label: "Select Purchase Order Number" }}
                      options={poNumbers}
                      onChange={(e) => selectPONumber(e)}
                      value={poNumbers.filter(function (option) {
                        return option.value.id === selectedPONumber.id;
                      })}
                    />
                  </div>
                  <div className="global-dropdown-block flex-center w-d100">
                    <label>
                      Notes and Instructions <span>Optional</span>
                    </label>
                    <textarea className="textarea" placeholder="2000 character limit" onChange={(e) => setRequestNote(e.target.value)}></textarea>
                  </div>
                  <div className="global-dropdown-block flex-center">
                    <label>
                      Tags <span>Optional</span>{" "}
                    </label>
                    <Select
                      classNamePrefix="cw"
                      className="global-dropdown-select"
                      menuShouldScrollIntoView={false}
                      closeMenuOnSelect={true}
                      placeholder="Select or enter a tag"
                      defaultValue={{ label: "Select or enter a tag" }}
                      options={filteredTags}
                      onChange={(e) => selectTag(e.value)}
                      onKeyDown={(e) => selectTagKeyDown(e)}
                      value={{ label: "Select or enter a tag" }}
                    />
                    <div className="multiselect-output flex">
                      {selectedTags.map((tag, tagIndex) => {
                        return (
                          <button aria-label="remove Albanian" key={tagIndex} onClick={() => removeTag(tag)}>
                            <strong>{tag.display}</strong>
                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                              <path
                                d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                stroke="#213248"
                                strokeWidth="1.5"
                                strokeLinecap="round"
                                strokeLinejoin="round"></path>
                            </svg>
                          </button>
                        );
                      })}
                    </div>
                  </div>
                </div>

                <h5 className="heading-width-border mar-bot30">Source Materials</h5>
                {validationErrors.sourceMaterial ? <div className="error">{validationErrors.sourceMaterial}</div> : null}
                <div className="translate-source-block">
                  <div className="upload-list materials-tab-content mar-bot20">
                    <div className="radio-form-check">
                      <input type="radio" className="form-check-input openOption" name="radio" id="uploadRadio" onChange={() => setRequestType("upload")} />
                      <label className="form-check-label" htmlFor="uploadRadio">
                        Upload your source materials (can be any file type). Create a .zip file to upload multiple files.
                      </label>
                    </div>
                    <div id="project-request-source-material" className="hide">
                      <SourceMaterialUpload />
                    </div>
                  </div>
                  <div className="sourc-material-addlink mar-bot20">
                    <div className="radio-form-check">
                      <input type="radio" className="form-check-input openOption" name="radio" id="addLink" onChange={() => setRequestType("desc")} />
                      <label className="form-check-label" htmlFor="addLink">
                        Add a link or description of your source material
                      </label>
                    </div>
                    <div className="global-dropdown-block mb-0 w-d100 hide">
                      <textarea className="textarea" placeholder="1000 characters limit" onChange={(event) => setDescriptiveSource(event.target.value)}></textarea>
                    </div>
                  </div>
                  {permissions?.ELOQUA_ACCESS && (
                    <div className="eloqua-assets mar-bot20">
                      <div className="radio-form-check">
                        <input
                          type="radio"
                          className="form-check-input integration-check-input"
                          name="radio"
                          id="eloquaAssets"
                          onChange={(event) => openIntegration(event, Constants.ELOQUA, Constants.ELOQUA_CONTENT_TYPE_DISPLAY, "eloqua")}
                          onClick={(event) => openIntegration(event, Constants.ELOQUA, Constants.ELOQUA_CONTENT_TYPE_DISPLAY, "eloqua")}
                        />
                        <label className="form-check-label" htmlFor="eloquaAssets">
                          Select your Eloqua Assets
                        </label>
                      </div>
                    </div>
                  )}
                  {permissions?.MARKETOREST_ACCESS && (
                    <div className="marketo-assets mar-bot20">
                      <div className="radio-form-check">
                        <input
                          type="radio"
                          className="form-check-input integration-check-input"
                          name="radio"
                          id="marketoAssets"
                          onChange={(event) => openIntegration(event, Constants.MARKETOREST, Constants.MARKETOREST_CONTENT_TYPE_DISPLAY, "marketov2")}
                          onClick={(event) => openIntegration(event, Constants.MARKETOREST, Constants.MARKETOREST_CONTENT_TYPE_DISPLAY, "marketov2")}
                        />
                        <label className="form-check-label" htmlFor="marketoAssets">
                          Select your Marketo v2.0 Assets
                        </label>
                      </div>
                    </div>
                  )}
                  {permissions?.BRIGHTCOVE_ACCESS && (
                    <div className="brightcove-assets mar-bot20">
                      <div className="radio-form-check">
                        <input
                          type="radio"
                          className="form-check-input integration-check-input"
                          name="radio"
                          id="brightcoveAssets"
                          onChange={(event) => openIntegration(event, Constants.BRIGHTCOVE, Constants.BRIGHTCOVE_CONTENT_TYPE_DISPLAY, "brightcove")}
                          onClick={(event) => openIntegration(event, Constants.BRIGHTCOVE, Constants.BRIGHTCOVE_CONTENT_TYPE_DISPLAY, "brightcove")}
                        />
                        <label className="form-check-label" htmlFor="brightcoveAssets">
                          Select your Brightcove Assets  {validationErrors?.msg?<span className="textDanger">{validationErrors?.msg}</span>:Constants.BLANK}
                        </label>
                      </div>
                    </div>
                  )}

                  {permissions?.UBERFLIP_ACCESS && (
                    <div className="brightcove-assets mar-bot20">
                      <div className="radio-form-check">
                        <input
                          type="radio"
                          className="form-check-input integration-check-input"
                          name="radio"
                          id="uberflipAssets"
                          onChange={(event) => openIntegration(event, Constants.UBERFLIP, Constants.UBERFLIP_CONTENT_TYPE_DISPLAY, "uberflip")}
                          onClick={(event) => openIntegration(event, Constants.UBERFLIP, Constants.UBERFLIP_CONTENT_TYPE_DISPLAY, "uberflip")}
                        />
                        <label className="form-check-label" htmlFor="uberflipAssets">
                          Select your Uberflip Assets  {validationErrors?.msg?<span className="textDanger">{validationErrors?.msg}</span>:Constants.BLANK}
                        </label>
                      </div>
                    </div>
                  )}

                  {projectRequestIntegrationRedux.selectedAssets?.length > 0 ?
                    <><div className="datatable-block custom_width">
                    <DataTable 
                     columns={assetColumns}
                     data={projectRequestIntegrationRedux.selectedAssets} 
                     highlightOnHover
                     responsive
                     striped
                     selectableRowsHighlight={true}
                     defaultSortFieldId={1}
                     theme={theme}
                     title={setTitle()}
                   />
                   </div><br /></>
                  :

                  <div className="step-2-section mar-bot30">
                    <div className="flex wrap-dropdown mb-0">
                      <div className="global-dropdown-block">
                        <label>What is your source language?</label>
                        <Select
                          classNamePrefix="cw"
                          className="global-dropdown-select"
                          menuShouldScrollIntoView={false}
                          closeMenuOnSelect={true}
                          defaultValue={{ label: "Select Source Language" }}
                          options={sourceLanguages}
                          onChange={(e) => handleSourceLanguageChange(e)}
                          value={sourceLanguages.filter(function (option) {
                            return option.value.code === selectedSourceLanguage.code;
                          })}
                        />
                        {validationErrors.sourceLanguage ? <div className="error">{validationErrors.sourceLanguage}</div> : null}
                      </div>
                      <div className="cust-arrow"></div>
                      <div className="global-dropdown-block">
                        <label className="white-space">What languages do you want to translate to?</label>
                        <Select
                          classNamePrefix="cw"
                          className="global-dropdown-select"
                          menuShouldScrollIntoView={false}
                          closeMenuOnSelect={true}
                          options={filteredTargetLanguage}
                          onChange={(e) => handleTargetLanguageChange(e)}
                          value={{
                            label: "Select...",
                            value: "",
                          }}
                        />
                        {validationErrors.requestTargetLanguages ? <div className="error">{validationErrors.requestTargetLanguages}</div> : null}
                        <div className="multiselect-output flex">
                          {selectedTargetLanguages.map((selectedTargetLangs, index) => {
                            return (
                              <button aria-label={`remove ${selectedTargetLangs.display}`} key={index} onClick={() => removeTargetLanguage(selectedTargetLangs)}>
                                <strong>{selectedTargetLangs.display}</strong>
                                <svg xmlns="http://www.w3.org/2000/svg" width="10" height="9" viewBox="0 0 10 9" fill="none">
                                  <path
                                    d="M1.50391 7.99067L4.99924 4.49533M8.49457 1L4.99857 4.49533M4.99857 4.49533L1.50391 1M4.99924 4.49533L8.49457 7.99067"
                                    stroke="#213248"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"></path>
                                </svg>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    </div>
                  </div>
                }
                </div>
                <h5 className="heading-width-border mar-bot30">Project Reference Matrials</h5>
                <div className="project-ref-matrial materials-tab-content">
                  <ReferenceMaterialUpload />
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {showIntegration && 
        <div>
          <ProjectRequestIntegrationMemo
            contentType={contentType}
            contentName={contentName}
            department={selectedDepartment}
          />
        </div>
      }
      <div className="stricy-btn flex flex-center no-rightlist justify-end">
        <div className="left flex">
          <div>
            <button className="btn-default">Cancel</button>
          </div>

          <div>
            <button className="btn-default" onClick={createRequest}>
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
